import React  from 'react';
import { Avatar, Grid, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/styles';
import { useRecoilState, useRecoilValue } from 'recoil';
import { errorsConfirmAccountState, confirmAccountState } from '../state/atoms';

const inputProps = {
    maxLength: 1
}

const TextInputCustom = styled((props) => <TextField {...props} />)
    (({ theme }) => ({
        '& .MuiOutlinedInput-input': {
            padding: '8px 5px 8px 5px',
            textAlign: 'center'
        }
    }))

const FormConfirmAccount = () => {

    const { confirmAccountErrors } = useRecoilValue(errorsConfirmAccountState);
    const [confirmAccount, setConfirmAccount] = useRecoilState(confirmAccountState);

    const handleChange = (ev) => {
        const { name, value } = ev.target;
        if (name === 'code1' && value !== '') document.getElementsByName('code2')[0].focus();
        if (name === 'code2' && value !== '') document.getElementsByName('code3')[0].focus();
        if (name === 'code3' && value !== '') document.getElementsByName('code4')[0].focus();
        if (name === 'code4' && value !== '') document.getElementsByName('code5')[0].focus();
        if (name === 'code5' && value !== '') document.getElementsByName('code6')[0].focus();

        if (name === 'code6' && value === '') document.getElementsByName('code5')[0].focus();
        if (name === 'code5' && value === '') document.getElementsByName('code4')[0].focus();
        if (name === 'code4' && value === '') document.getElementsByName('code3')[0].focus();
        if (name === 'code3' && value === '') document.getElementsByName('code2')[0].focus();
        if (name === 'code2' && value === '') document.getElementsByName('code1')[0].focus();

        setConfirmAccount({
            ...confirmAccount,
            [name]: value
        });
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12} md={12} justifyContent={"center"} display={"flex"}>
                    <Typography variant="subtitle1" color="primary">
                        Enviamos un mail de confirmación a su correo electrónico
                    </Typography>
                </Grid>

                <Grid item xs={12} md={12} justifyContent={"center"} display={"flex"} mt={3}>
                    <Avatar style={{ width: 100, height: 100, backgroundColor: '#F2F8FB' }}>
                        <img
                            width={48}
                            height={48}
                            alt="img-mail"
                            src={`${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/mail.png`}
                        />
                    </Avatar>
                </Grid>

                <Grid item container xs={12} md={12} mt={3}>
                    <Grid item xs={12} md={12}>
                        <Typography variant="h6" color={grey[500]} justifyContent={"center"} display={"flex"}>
                            Código de confirmación
                        </Typography>

                    </Grid>

                    <Grid container xs={12} md={12} item mt={2} pl={1} pr={1} display={"flex"} justifyContent={"center"}>
                        <Grid container item maxWidth={350} spacing={2}>
                            <Grid item xs={2} md={2}>
                                <TextInputCustom
                                    name="code1"
                                    type="text"
                                    size='small'
                                    inputProps={inputProps}
                                    autoFocus
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={2} md={2}>
                                <TextInputCustom
                                    name="code2"
                                    type="text"
                                    size='small'
                                    inputProps={inputProps}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={2} md={2}>
                                <TextInputCustom
                                    name="code3"
                                    type="text"
                                    size='small'
                                    inputProps={inputProps}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={2} md={2}>
                                <TextInputCustom
                                    name="code4"
                                    type="text"
                                    size='small'
                                    inputProps={inputProps}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={2} md={2}>
                                <TextInputCustom
                                    name="code5"
                                    type="text"
                                    size='small'
                                    inputProps={inputProps}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={2} md={2}>
                                <TextInputCustom
                                    name="code6"
                                    type="text"
                                    size='small'
                                    inputProps={inputProps}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {
                confirmAccountErrors.length > 0 && (
                    <Grid item xs={12} md={12} display={"flex"} justifyContent={"center"} mt={2}>
                        <Typography color="error" fontSize={"0.75rem"}>{confirmAccountErrors.join("\n")}</Typography>
                    </Grid>
                )
            }
        </>
    )
}

export default FormConfirmAccount;